import { create } from 'zustand';
import type { UserPublic } from '@forest/contracts';

type SessionState = {
  user: UserPublic | null;
  ready: boolean;
  setUser: (u: UserPublic | null) => void;
  clear: () => void;
  setReady: (v: boolean) => void;
};

export const useAuthStore = create<SessionState>((set) => ({
  user: null,
  ready: false,
  setUser: (u) => set({ user: u }),
  clear: () => set({ user: null }),
  setReady: (v) => set({ ready: v }),
}));
